module.exports = __webpack_public_path__ + "img/fw7.7303b540.png";